import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Invoice } from './Invoice';
import { Invoice2 } from './Invoice2';
import { Invoice3 } from './Invoice3';
import { Invoice3Void } from './Invoice3Void';
import { ExchangeOrder } from './ExchangeOrder';
import { Quotation } from './Quotation';
import { Receipt } from './Receipt';
import { CreditNote } from './CreditNote';
import { Bill } from './Bill';
import { PaxStatement } from './PaxStatement';
import { PaxStatement2 } from './PaxStatement2';
export function DocumentSystem() {
  const [activeDocument, setActiveDocument] = useState('invoice-3');
  const sampleReceiptData = {
    receiptNo: 'RCP-2025-001',
    receiptDate: '20 January 2025',
    bookingRef: 'BKG-2025-TR-889',
    gstRegNo: '201234567G',
    tourCode: 'TOUR-JP-001',
    paymentMethod: 'Credit Card',
    collectedBy: 'Sarah Chen',
    printedBy: 'System Admin',
    currency: 'SGD',
    amountReceived: 3000.0,
    totalAmount: 7628.2,
    balanceDue: 4628.2,
    customerName: 'ANDERSON / JAMES MR',
    paymentTime: '20 Jan 2025, 3:45 PM',
    remarks: 'Partial payment received for Japan tour package. Balance to be paid 14 days before departure date.',
    notes: 'Payment received via Visa ending in 4242. Transaction ID: TXN-20250120-001.\n\nReceipt issued upon request. Please retain this receipt for your records and future reference.',
    terms: '1. This receipt is valid only for the amount stated above.\n2. No refunds will be processed without this receipt.\n3. Balance payment must be received 14 days before tour departure.\n4. Late payment may result in booking cancellation.\n5. For queries, please contact our accounts department at accounts@mytourix.com.',
    companyInfo: {
      name: 'MyTourix Travel Management',
      logo: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=200&h=80&fit=crop',
      address: '123 Orchard Road, #12-34\nSingapore 238858',
      contact: 'Tel: +65 6789 1234 | Email: accounts@mytourix.com'
    }
  };
  const renderDocument = () => {
    switch (activeDocument) {
      case 'invoice':
        return <Invoice data-id="element-257" />;
      case 'invoice-2':
        return <Invoice2 data-id="element-258" />;
      case 'invoice-3':
        return <Invoice3 data-id="element-259" />;
      case 'invoice-3-void':
        return <Invoice3Void data-id="element-260" />;
      case 'exchange-order':
        return <ExchangeOrder data-id="element-261" />;
      case 'quotation':
        return <Quotation data-id="element-262" />;
      case 'receipt':
        return <div className="h-full overflow-auto bg-gradient-to-br from-neutral-50 to-neutral-100 p-6" data-id="element-263">
            <div className="w-[210mm] min-h-[297mm] max-h-[297mm] mx-auto bg-white shadow-lg rounded-xl p-8 flex flex-col" data-id="element-264">
              <Receipt {...sampleReceiptData} data-id="element-265" />
            </div>
          </div>;
      case 'credit-note':
        return <CreditNote data-id="element-266" />;
      case 'bill':
        return <Bill data-id="element-267" />;
      case 'pax-statement':
        return <PaxStatement data-id="element-268" />;
      case 'pax-statement-2':
        return <PaxStatement2 data-id="element-269" />;
      default:
        return null;
    }
  };
  return <div className="flex h-screen overflow-hidden" data-id="element-270">
      <Sidebar activeDocument={activeDocument} onDocumentChange={setActiveDocument} data-id="element-271" />
      <main className="flex-1 overflow-hidden" data-id="element-272">{renderDocument()}</main>
    </div>;
}